export default function sortBy(array, predicate) {
	return array.sort((a, b) => {
		const elemA = predicate(a);
		const elemB = predicate(b);
		return elemA > elemB ? 1 : elemB > elemA ? -1 : 0;
	});
}
